import api from "../lib/api";

export const getResult = (payload: any) =>
  api.post("/api/search/search", payload);

const withPagination = ({ page = 1, limit = 10 } = {}) =>
  `?page=${page}&limit=${limit}`;

export const getSearchHighCourts = async (payload: any, pagination?: any) => {
  const res: any = await api.post(
    `/api/search/highcourts${withPagination(pagination)}`,
    payload,
  );
  return res?.data;
};
export const getSearchBenches = async (payload: any, pagination?: any) => {
  const res: any = await api.post(
    `/api/search/benches${withPagination(pagination)}`,
    payload,
  );
  return res?.data;
};
export const getSearchBenchRooms = async (payload: any, pagination?: any) => {
  const res: any = await api.post(
    `/api/search/bench-rooms${withPagination(pagination)}`,
    payload,
  );
  return res?.data;
};

// ------------------------------District----------------------------

export const getSearchDistricts = async (payload: any, pagination?: any) => {
  const res: any = await api.post(
    `/api/search/districts${withPagination(pagination)}`,
    payload,
  );
  return res?.data;
};
export const getSearchComplexes = async (payload: any, pagination?: any) => {
  const res: any = await api.post(
    `/api/search/complexes${withPagination(pagination)}`,
    payload,
  );
  return res?.data;
};
export const getSearchEstablishments = async (
  payload: any,
  pagination?: any,
) => {
  const res: any = await api.post(
    `/api/search/establishments${withPagination(pagination)}`,
    payload,
  );
  return res?.data;
};
export const getSearchCourtRooms = async (payload: any, pagination?: any) => {
  const res: any = await api.post(
    `/api/search/court-rooms${withPagination(pagination)}`,
    payload,
  );
  return res?.data;
};
